import React from 'react'
import PropTypes from 'prop-types'
import SeriesHome from '@shared/components/series/seriesHome'
import SeriesNews from '@shared/components/series/seriesNews'
import SeriesFantasyArticle from '@shared/components/series/seriesFantasyArticle'
import SeriesVideos from '@shared/components/series/seriesVideos'

function TagPlayerTeamDetail({ tag, seoData, activeTab, onTabChanges }) {
  if (activeTab === 'home') {
    return <SeriesHome data={tag?.home} category={tag?.data} onTabChanges={onTabChanges} />
  } else if (activeTab === 'news') {
    return <SeriesNews category={{ ...tag?.data, iId: seoData?.iId }} isClientOnly />
  } else if (activeTab === 'fantasyArticle') {
    return <SeriesFantasyArticle category={tag?.data} isClientOnly />
  } else if (activeTab === 'videos') {
    return <SeriesVideos category={tag?.data} isClientOnly />
  } else {
    return null
  }
}
TagPlayerTeamDetail.propTypes = {
  seoData: PropTypes.object,
  tag: PropTypes.object,
  activeTab: PropTypes.string,
  onTabChanges: PropTypes.func
}
export default TagPlayerTeamDetail
